module.exports = __webpack_public_path__ + "static/img/bg.4c4a62a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/bg.jpg
// module id = y2Z/
// module chunks = 7